import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';

import { fetchRefundsBreakdownReport } from './actions';

export default compose(
  connect(
    null,
    {
      fetchReport: fetchRefundsBreakdownReport,
    }
  ),
  withProps(() => ({
    title: 'refunds',
    csvJobName: 'refunded-breakdown-report',
  })),
);
